import { Alert, Container, Grid } from '@mui/material';
import Localization from 'l18n/l18n';
import Appointments from 'models/appointments';
import * as React from 'react';
import { useParams } from 'react-router';
import PatientInfo from './components/patient_info';
import PatientTabs from './components/patient_tabs';


function PatientReport (props) {

    const { patient_info_id : patientId} = useParams    () ;
    const [isError,setIsError] = React.useState(false) ;
    const [isEmpty,setIsEmpty] = React.useState(false) ;
    const [isLoading, setIsLoading] = React.useState(false) ;
    const [patientReportInfo,setPatientReportInfo] = React.useState({}) ;

    
    
    const getPatientReport = async (patientId)=>{
        
        await Appointments.getPatientReport(patientId).then(async (patientReport) => {
            if(patientReport.length < 1){
                setIsEmpty(true);
            }
            const response = await patientReport[0] ;
            setPatientReportInfo(response);
            setIsLoading(false); 
        }).catch((error) => {
        console.log(error);
        setIsError(true);
        setIsLoading(false);
        });
        
    };
    React.useEffect(() => {
        setIsLoading(true);
        setIsError(false);
        getPatientReport(patientId);
    
    },[patientId]);
 
    if(isError){
        return   <Alert severity="error">{Localization.translate['error']}</Alert> ;
    }
    if(isEmpty){
        return   <Alert severity="warning">{Localization.translate['patient_not_found']}</Alert> ;
    } 

    return (
        <Container maxWidth="lg">
            <Grid container>
                <Grid item xs={12}>
                    <PatientInfo {...patientReportInfo}/>
                </Grid>
                <Grid item xs={12}>
                    <PatientTabs patientReport={patientReportInfo}/>
                </Grid>
            </Grid>
        </Container>
    );
}

export default PatientReport;